import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import clsx from 'clsx';

import {
  actionGetFiltersSignals,
  actionGetSignals,
} from '../../../redux/action/tunder/actionSignals';
import { AppDispatch } from '../../../redux/reducer/store';
import {
  reducerSignalsInputValues,
  reducerSignalsStatus,
} from '../../../redux/reducer/tunder/reducers/reducerSignals';

import LimitSelect from '../../custom/limitSelect/limitSelect';
import Pagination from '../../pagination/pagination';
import Loader from '../../custom/loader/loader';
import RangeDatePicker from '../../custom/rangeDatePicker/rangeDatePicker';

import '../table.scss';
import { IUserOptions } from '../../../types/interfaces';
import CustomMultiSelect from '../../custom/customMultiSelect/customMultiSelect';
import toast, { Toaster } from 'react-hot-toast';
import { generateStyles } from '../../../utils/generateToastStyles';
import ToastPopup from '../../custom/toastPopup/toastPopup';

interface ISignals {
  address: string;
  contract: string;
  contractId: number;
  count: number;
  date: string;
  employee: string;
  employeeId: string;
  id: number;
  isAvailable: boolean;
  isVirtualRestRisk: boolean;
  posId: number;
  productCode: string;
  productName: string;
  shopCode: string;
  report?: {
    id: number;
    name: string;
  };
}

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableSignals: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const {
    filters,
    formattedDateFrom,
    formattedDateTo,
    limit,
    offset,
    signals,
    signalsCount,
    signalsInputValues,
    status,
  } = useSelector((state: any) => state.tunder.signals);

  const { customerInputValues } = useSelector(
    (state: any) => state.roles.customerList,
  );

  const { isOpenSidebar, data } = useSelector(
    (state: IUserOptions) => state.user.user,
  );

  const [isPending, setIsPending] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startPage, setStartPage] = useState<number>(1);

  const actualLimit =
    JSON.parse(localStorage.getItem('pageLimit') as string) || limit;

  useEffect(() => {
    setIsPending(true);
    dispatch(actionGetSignals(actualLimit, offset)).then(() => {
      setIsPending(false);
    });
    dispatch(actionGetFiltersSignals()).then(() => {
      setIsPending(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetPages = () => {
    setCurrentPage(1);
    setStartPage(1);
  };

  const handleChange = (newLimit: number, newOffset: number) => {
    setIsPending(true);
    dispatch(actionGetSignals(newLimit, newOffset)).then(() => {
      setIsPending(false);
    });
    localStorage.setItem('pageLimit', JSON.stringify(newLimit));
  };

  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 0);
    setCurrentPage(1);
    setStartPage(1);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    dispatch(reducerSignalsInputValues({ [name]: value }));
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setIsPending(true);
      dispatch(actionGetSignals(limit, offset)).then(() => {
        setIsPending(false);
      });
      resetPages();
    }
  };

  useEffect(() => {
    if (status === 205) {
      toast(
        (t) => (
          <ToastPopup
            title={`Список сигналов Тандер будет отправлен на почту ${data.email}, когда будет сформирован`}
            isSuccess={true}
            toast={toast}
            t={t}
          />
        ),
        generateStyles(true),
      );
    } else if (status === 400) {
      toast(
        (t) => (
          <ToastPopup
            title='Ошибка при выгрузке сигналов'
            isSuccess={false}
            toast={toast}
            t={t}
          />
        ),
        generateStyles(),
      );
    }

    setTimeout(() => {
      dispatch(reducerSignalsStatus(null));
    }, 5000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, status]);

  return (
    <>
      <div className='loader__wrapper'>
        {(!signals || isPending) && <Loader />}
      </div>
      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
            isOpenSidebar &&
            'active__table',
          !isOpenSidebar && 'closed__table',
          'table',
        )}
      >
        {(status || status !== null) && (
          <Toaster
            position='top-center'
            toastOptions={{
              duration: 5000,
            }}
          />
        )}
        <div className="filters__container__mobile">
          <div className='filters__item__mobile'>
            <RangeDatePicker
              setLoading={setIsPending}
              reducer={reducerSignalsInputValues}
              defaultDateFrom={formattedDateFrom}
              inputValues={signalsInputValues}
              defaultDateTo={formattedDateTo}
              setCurrentPage={setCurrentPage}
              action={actionGetSignals}
              setStartPage={setStartPage}
              limit={actualLimit}
              page={0}
              placeholder='Дата'
              pageName='signals'
            />
          </div>
          <div className='filters__item__mobile'>
            <div className='reports__contract_block'>
              <CustomMultiSelect
                setLoading={setIsPending}
                reducer={reducerSignalsInputValues}
                inputValues={signalsInputValues}
                action={actionGetSignals}
                options={filters.contracts}
                isShowPlaceholder={true}
                resetPages={resetPages}
                placeholder='Контракты'
                pageName='clientsList'
                name='contract'
                offset={0}
                limit={limit}
              />
            </div>
          </div>
          <div className='filters__item__mobile'>
            <div className='filter__number_block'>
              <input
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                name='shopCode'
                placeholder=''
                type='number'
              />
              <label>ID TT Тандер</label>
            </div>
          </div>
          <div className='filters__item__mobile'>
            <div className='filter__block'>
              <input
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                autoComplete='off'
                placeholder=' '
                name='address'
                type='text'
              />
              <label>Адрес TT Тандер</label>
            </div>
          </div>
          <div className='filters__item__mobile'>
            <div className='reports__contract_block'>
              <CustomMultiSelect
                setLoading={setIsPending}
                reducer={reducerSignalsInputValues}
                inputValues={customerInputValues}
                action={actionGetSignals}
                options={filters.productCode}
                isShowPlaceholder={true}
                resetPages={resetPages}
                placeholder='Код товара Тандер'
                pageName='productCode'
                name='productCode'
                offset={0}
                limit={limit}
              />
            </div>
          </div>
          <div className='filters__item__mobile'>
            <div className='filter__block'>
              <input
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                autoComplete='off'
                placeholder=' '
                name='product'
                type='text'
              />
              <label>Товар Тандер</label>
            </div>
          </div>
          <div className='filters__item__mobile'>
            <div className='reports__contract_block'>
              <CustomMultiSelect
                setLoading={setIsPending}
                reducer={reducerSignalsInputValues}
                inputValues={customerInputValues}
                action={actionGetSignals}
                options={filters.merches}
                isShowPlaceholder={true}
                resetPages={resetPages}
                placeholder='Мерчендайзер'
                pageName='employee'
                name='employee'
                offset={0}
                limit={limit}
              />
            </div>
          </div>
        </div>
        <div className='table__wrapper'>
          <table>
            <thead className='tunder__thead table__header__filters'>
              <tr>
                <th className='signals__date_cell'>
                  <RangeDatePicker
                    setLoading={setIsPending}
                    reducer={reducerSignalsInputValues}
                    defaultDateFrom={formattedDateFrom}
                    inputValues={signalsInputValues}
                    defaultDateTo={formattedDateTo}
                    setCurrentPage={setCurrentPage}
                    action={actionGetSignals}
                    setStartPage={setStartPage}
                    limit={actualLimit}
                    page={0}
                    placeholder='Дата'
                    pageName='signals'
                  />
                </th>
                <th>
                  <div className='reports__contract_block'>
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      reducer={reducerSignalsInputValues}
                      inputValues={signalsInputValues}
                      action={actionGetSignals}
                      options={filters.contracts}
                      isShowPlaceholder={true}
                      resetPages={resetPages}
                      placeholder='Контракты'
                      pageName='clientsList'
                      name='contract'
                      offset={0}
                      limit={limit}
                    />
                  </div>
                </th>

                <th>
                  <div className='filter__number_block'>
                    <input
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      name='shopCode'
                      placeholder=''
                      type='number'
                    />
                    <label>ID TT Тандер</label>
                  </div>
                </th>
                <th>
                  <div className='filter__block'>
                    <input
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      autoComplete='off'
                      placeholder=' '
                      name='address'
                      type='text'
                    />
                    <label>Адрес TT Тандер</label>
                  </div>
                </th>
                <th>
                  <div className='reports__contract_block'>
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      reducer={reducerSignalsInputValues}
                      inputValues={customerInputValues}
                      action={actionGetSignals}
                      options={filters.productCode}
                      isShowPlaceholder={true}
                      resetPages={resetPages}
                      placeholder='Код товара Тандер'
                      pageName='productCode'
                      name='productCode'
                      offset={0}
                      limit={limit}
                    />
                  </div>
                </th>
                <th>
                  <div className='filter__block'>
                    <input
                      onChange={handleInputChange}
                      onKeyPress={handleKeyPress}
                      autoComplete='off'
                      placeholder=' '
                      name='product'
                      type='text'
                    />
                    <label>Товар Тандер</label>
                  </div>
                </th>
                <th>
                  <span className='filter__title'>Отчет Mol</span>
                </th>
                <th>
                  <div className='reports__contract_block'>
                    <CustomMultiSelect
                      setLoading={setIsPending}
                      reducer={reducerSignalsInputValues}
                      inputValues={customerInputValues}
                      action={actionGetSignals}
                      options={filters.merches}
                      isShowPlaceholder={true}
                      resetPages={resetPages}
                      placeholder='Мерчендайзер'
                      pageName='employee'
                      name='employee'
                      offset={0}
                      limit={limit}
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {signals &&
                signals.map((outlet: ISignals) => {
                  return (
                    <tr key={outlet.date + outlet.count + outlet.productCode + outlet.shopCode + outlet.address + outlet.contract + outlet.employee + outlet.productName + outlet.report?.name}>
                      <td>{outlet.date?.split('-')?.reverse()?.join('.')}</td>
                      <td>{outlet.contract}</td>
                      <td>{outlet.shopCode}</td>
                      <td>{outlet.address}</td>
                      <td>{outlet.productCode}</td>
                      <td>{outlet.productName}</td>
                      <td>{outlet.report?.name}</td>
                      <td>{outlet.employee}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <div className='pagination'>
          <div className='pagination__count'>Всего: {signalsCount}</div>
          <div className='pagination__str'>
            <span>Отображать строки</span>
            <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
          </div>
          <Pagination
            setCurrentPage={setCurrentPage}
            setStartPage={setStartPage}
            handleChange={handleChange}
            currentPage={currentPage}
            startPage={startPage}
            count={signalsCount}
            limit={actualLimit}
          />
        </div>
      </div>
    </>
  );
};

export default TableSignals;
